module.exports = __webpack_public_path__ + "static/media/page-04.fa633471.png";